import {
  AxiosError,
  AxiosResponse
} from "axios";

export interface IApiError {
  status: number;
  type: JSONApiErrorType;
  message: string;
  title: string;
  data?: Record<string, any>;
}

interface JSONApiResponse<T = any> {
  status: number;
  meta?: JSONApiMeta;
  data?: T;
  errors?: JSONApiError[];
}

interface JSONApiMeta {
  environment?: string;
  resource?: string;
  url?: string;
  httpMethod?: string;
  functionName?: string;
}

export interface JSONApiError {
  type: JSONApiErrorType;
  status: number;
  source?: {
    pointer?: string;
    url?: string;
    data?: any;
  };
  title: string;
  details: string;
  errors?: JSONApiError[];
}

type JSONApiErrorType =
  | "api_maintenance_error"
  | "api_connection_error"
  | "api_error"
  | "authentication_error"
  | "authentication_error_suspended"
  | "invalid_request_error"
  | "db_error"
  | "not_found"
  | "unknown_error";

export default (error: AxiosError): IApiError => {
  const errorData: AxiosResponse<JSONApiResponse> | undefined = error.response;
  let isJSONApiError: string | false | 0 | undefined = false;
  let JSONApiError: JSONApiResponse | undefined;

  // If there is an known error response
  if (errorData) {
    isJSONApiError =
      errorData &&
      errorData.data &&
      errorData.status &&
      errorData.data.errors &&
      errorData.data.errors.length > 0 &&
      errorData.data.errors[ 0 ].title &&
      errorData.data.errors[ 0 ].details;

    // Check if the error is a JSON API error
    if (isJSONApiError) {
      JSONApiError = errorData.data;

      // TSC if statement to remove warnings
      if (JSONApiError && JSONApiError.errors) {
        return {
          status: errorData.status,
          type: JSONApiError.errors[ 0 ].type,
          title: JSONApiError.errors[ 0 ].title,
          message: JSONApiError.errors[ 0 ].details
        };
      }
    }

    return {
      status: errorData.status,
      type: "not_found",
      title: "Unknown error occurred.",
      message: "An unknown error has occurred. If the problem continues to exist, please contact one of the administrators."
    };
  }

  return {
    status: 500,
    type: "unknown_error",
    title: "Unknown error occurred.",
    message: "An unknown error occurred. Please make sure you are connected to the internet and try again."
  };
};

export const getMessageFromErrors = (error: JSONApiResponse) => {
  if (error.errors && error.errors[ 0 ] && error.errors[ 0 ].details) {
    return error.errors[ 0 ].details;
  }

  return "An unknown error occurred. Please make sure you are connected to the internet and try again.";
};
